<template>
  <div class="header">
    <div style="display: none">
      <audio controls="controls" autoplay="autoplay">
<!--        <source src="../assets/music.mp3" type="audio/mpeg" />-->
      </audio>
    </div>
    <div class="banner">
      <div class="img" :style="banner"></div>
      <!-- <div class="line"></div> -->
      <!-- <div class="login">
        <div v-if="!$store.state.loginState">尊敬的参赛者，请<span @click="gologin">「登录」</span></div>
        <div class="personal" v-if="$store.state.loginState">
          <div class="guang"><img src="../assets/guang.png" /></div>
          <a @click="goPage('/personal','')" ><img src="../assets/ren.png" />个人中心</a>
          <a class="lhmj" target="_blank" @click="toLhmj">蓝海密剑</a>
        </div>
      </div> -->
      <div class="navs">
        <div class="navscon">
          <div class="mainnavs">
            <a @click="goPage('/','sy')">
              <div :class="[{'active':$store.state.active=='sy'}]" @click="$store.state.active='sy'">首页</div>
            </a>
            <a @click="goPage('/rules','xz')">
              <div :class="[{'active':$store.state.active=='xz'}]">大赛细则</div>
            </a>
            <a @click="goPage('/rank','ph')">
              <div :class="[{'active':$store.state.active=='ph'}]">当届榜单</div>
            </a>
            <a @click="goPage('/news','gg')">
              <div :class="[{'active':$store.state.active=='gg'}]">新闻公告</div>
            </a>
          <!-- <div style="display: inline-block;width: 210px;height:100px;"> -->
            <a @click="gosignup('bm')">
              <div :class="[{'active':$store.state.active=='bm'}]">报名参赛</div>
            </a>
            <!-- @click="isLjph = 'show'" -->
            <a  @click="showLjph">
              <div :class="[{'active':$store.state.active=='sph'}]">历届榜单</div>
            </a>
            <a target="_blank" @click="toLhmj">
              <div>期货大赛</div>
            </a>
            <div class="loginInfo">
              <div v-if="!$store.state.loginState"><img src="../assets/ren.png" /><span @click="gologin">点击登录</span></div>
              <div class="personal" v-if="$store.state.loginState" :class="[{'active':$store.state.active=='per'}]">
                <a @click="goPage('/personal','per')" ><img src="../assets/ren.png" />个人中心</a>
              </div>
            </div>
            <!-- </div> -->
          </div>
          <div class="prevRanking" :class="[{'show':isLjph == 'show'}]">
            <!-- <div @click="goPage('/prevRank','2')">2022赛季</div> -->
            <div @click="goPage('/prevRank','2')">2021赛季</div>
            <div @click="goPage('/prevRank','1')">2020赛季</div>
          </div>
        </div>
        <login v-if="showlogin" @closelogin="closelogin" @goaffirm="goaffirm" @goforgetpwd="goforgetpwd"
               @gosurvey="gosurvey"></login>
        <affirm v-if="showaffirm" @closeaffirm="closeaffirm" @goreg="goreg"></affirm>
        <reg v-if="showreg" @closereg="closereg" @gologin="gologin"></reg>
        <forgetpwd v-if="showforgetpwd" @closeforgetpwd="closeforgetpwd" @pwdgologin="pwdgologin"></forgetpwd>
        <survey v-if="showsurvey" @closesurvey="closesurvey"></survey>
        <notice v-if="$store.state.noticeMessage!=''" :noticeMessage="$store.state.noticeMessage"
                @sureClose="sureClose"></notice>
      </div>
    </div>
<!--    <div :class="['fix',{'hide':!showad}]"><span @click="hidead">×</span><img src="../assets/lhmjad.png" /></div>-->
  </div>
</template>
<script>
  import {http} from '../fetch/api'
  import login from './login'
  import affirm from './affirm'
  import reg from './reg'
  import survey from './survey'
  import forgetpwd from './forgetpwd'
  import format from '../fetch/format'
  // import risknotice from './risknotice'

  export default {
    components: {
      login,
      affirm,
      reg,
      survey,
      forgetpwd
      // risknotice
    },
    data() {
      return {
        // active: "sy",
        showlogin: false,
        showaffirm: false,
        showreg: false,
        showsurvey: false,
        showforgetpwd: false,
        loginstate: false,
        // showrisknotice: false,
        type: "",
        basicInfo:{},
        showad: true,
        banner:"",
        isLjph:"",
        series:""
      }
    },
    created(){
      // 个人中心注销账号后弹出登录框
      this.$bus.$on('brotherEvent', res=>{
        this.showlogin = true
      })
    },

    mounted() {
      this.getLoginState()
      this.getBanner()
      console.log(this.$store.state.loginState)
    },
    methods: {
      async getBanner() {
      var data = await http.getBanner()
      this.banner = "background-image:url("+data.data[0].src+")"
      },
      hidead() {
        this.showad=false
      },
      goPage(path,active) {
        this.isLjph = ""
        this.series = active
        if(path=='/rank'&&!this.$store.state.loginState) {
          this.showlogin=true
          this.type='rank'
        }else if(path=='/prevRank'&&!this.$store.state.loginState){
          this.showlogin=true
          this.type='prevRank'
        }else if(path=='/prevRank'&&this.$store.state.loginState){
          this.active = "sph"
          this.$router.push({path:path,query: {session:active}})
        }else {
          this.$store.state.active=active
          var temp=format.formatKeys(this.$route.query)
          var params=temp.substring(0,temp.length-1)
          this.$router.push(path+"?"+params)
        }
      },
      sureClose() {
        this.$store.state.noticeMessage = ""
      },
      showLjph(){
        if(this.isLjph) {
          this.isLjph = ""
        }else {
          this.isLjph = "show"
        }
      },
      async gosignup(active) {
        this.isLjph = ""
        if (this.$store.state.loginState) {
          var temp=format.formatKeys(this.$route.query)
          var params=temp.substring(0,temp.length-1)
          if (window.localStorage.institutId != 'null') {//是否已经填写私募管理人信息
            var data = await http.basicInfo()
            this.basicInfo = data.data
            if (this.basicInfo && this.basicInfo.institut && ((this.basicInfo.institut.productList&& this.basicInfo.institut.productList.length < 8)||(!this.basicInfo.institut.productList))) {
              if(this.basicInfo.institut.productList) {
                window.localStorage.productList = this.basicInfo.institut.productList.length
              } else {
                window.localStorage.productList = 0
              }
              this.$store.state.active = active
              console.log(active)
              this.$router.push("/signup?"+params)
            } else {
              window.localStorage.productList = 8
              this.$store.state.noticeMessage = "您已有8个产品参赛，暂不能报名"
              return
            }
          } else {
            this.$store.state.active = active
            this.$router.push("/manager?"+params)
          }
        } else {
          this.showlogin = true
          this.type = "signup"
        }
      },
      closereg() {
        this.showreg = false
      },
      closeforgetpwd() {
        this.showforgetpwd = false
      },
      closeaffirm() {
        this.showaffirm = false
      },
      closesurvey() {
        this.showsurvey = false
      },
      gologin() {
        this.showreg = false
        this.showlogin = true
        this.type = ""
      },
      pwdgologin() {
        this.showforgetpwd=false
        this.showlogin=true
        this.type=""
      },
      gosurvey() {
        this.showlogin = false
        //隐藏掉调查问卷
        // this.showsurvey = true
      },
      goreg() {
        this.showaffirm = false
        this.showreg = true
      },
      goaffirm() {
        this.showlogin = false
        this.showaffirm = true
      },
      goforgetpwd() {
        this.showlogin = false
        this.showforgetpwd = true
      },
      async getLoginState() {
        var data = await http.loginState()
        if (data.code == '0') {
          this.$store.state.loginState = true
        } else if (data.code == '1') {
          this.$store.state.loginState = false
        }
      },
      closelogin(only) {
        console.log(this.type,"header")
        this.showlogin = false
        if (only == 'only') {

        } else {

          if (!this.type) {
            // this.$router.push({"path":"/personal"})
          } else {
            var temp=format.formatKeys(this.$route.query)
            var params=temp.substring(0,temp.length-1)
            // this.$router.push("/personal?"+params)
            if(this.type=='rank') {//跳转到排行榜页面
              this.$router.push("/rank?"+params)
              this.$store.state.active='ph'
            }else if(this.type=='prevRank') {//跳转到上赛季排行页面
              this.$router.push("/prevRank?"+params + "session=" + this.series)
              this.$store.state.active='sph'
            } else if(this.type=='signup') {//从报名参赛点进来
              this.$store.state.active=''
              if (window.localStorage.institutId != 'null') {//已填写私募管理人信息
                this.$router.push("/signup?"+params)
              } else {//未填写私募管理人信息
                this.$router.push("/manager?"+params)
              }
            }
          }
        }
      },
      toLhmj(){
        window.open(window.location.href.split('/pof/')[0])
      }
    }
  }
</script>
<style scoped>
  .showqd {
    position: relative;
    display: inline-block;
  }
  .showqd span {
    display: none;
    position: absolute;
    width: 140px;
    color: #595a77;
    border-radius: 3px;
    right: -100px;
    bottom: 0;
    font-size: 14px;
    background: #fff;
    padding: 5px;
    z-index: 1;
  }
  .showqd:hover span {
    display: inline-block;

  }
  .header {
    min-width: 1200px;
  }
  .banner {
    position: relative;
    background-size: cover;
    text-align: center;
  }
  .banner .img {
    /* background-image: url("../assets/banner.png"); */
    background-position: center;
    background-size: cover;
    height: 500px;
  }
  .line {
    width: 100%;
    position: absolute;
    height: 20px;
    top: 0;
    /*background: rgba(0,0,0,.5);*/
    background-image: -webkit-linear-gradient(-90deg,#0b112a 0%,#120916 54%,#180101 100%);
    background-image: -moz-linear-gradient(-90deg,#0b112a 0%,#120916 54%,#180101 100%);
    background-image: -o-linear-gradient(-90deg,#0b112a 0%,#120916 54%,#180101 100%);
    background-image: linear-gradient(-90deg,#0b112a 0%,#120916 54%,#180101 100%);
    opacity: 0.56;
  }
  .login {
    position: absolute;
    width: 100%;
    color: #c0b5d8;
    right: 0px;
    top: 40px;
  }

  .login div {
    width: 1200px;
    text-align: right;
    margin: 0 auto;
  }

  .login span {
    cursor: pointer;
    color: #fff;
  }

  .bannertext {
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
    display: inline-block;
    width: 60%;
  }

  .bannertext img {
    width: 100%;
  }

  .navs {
    text-align: center;
    position: absolute;
    width: 100%;
    height: 100px;
    bottom: 0;
    background: -webkit-linear-gradient(left, rgba(29, 82, 159, 0.8), rgba(44, 12, 87, 0.8)); /* Safari 5.1 - 6.0 */
    background: -o-linear-gradient(right, rgba(29, 82, 159, 0.8), rgba(44, 12, 87, 0.8)); /* Opera 11.1 - 12.0 */
    background: -moz-linear-gradient(right, rgba(29, 82, 159, 0.8), rgba(44, 12, 87, 0.8)); /* Firefox 3.6 - 15 */
    background: linear-gradient(to right, rgba(29, 82, 159, 0.8), rgba(44, 12, 87, 0.8)); /* 标准的语法 */

    border-top: 2px transparent solid;
    border-bottom: 2px transparent solid;
    border-image: -webkit-linear-gradient(to right, #5578c8, #313996) 1 10;
    border-image: -o-linear-gradient(to right, #5578c8, #313996) 1 10;
    border-image: -moz-linear-gradient(to right, #5578c8, #313996) 1 10;
    border-image: linear-gradient(to right, #5578c8, #313996) 1 10;
  }

  .navscon {
    width: 1290px;
    position: relative;
    margin: 0 auto;
    text-align: left;
  }

  .mainnavs {
    /* width: 1085px; */
    display: inline-block;
  }

  .mainnavs div {
    display: inline-block;
    font-size: 26px;
    color: #e5e5e5;
    width: 150px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .mainnavs div.active {
    width: 150px;
    background: url("../assets/navactive.png") no-repeat;
    background-size: cover;
    color: #fff;
  }
  .mainnavs div.gray {
    color:#595a77;
  }
  .signup {
    position: absolute;
    text-align: center;
    right: 0;
    bottom: -2px;
    display: inline-block;
    width: 210px;
    height: 100px;
    line-height: 100px;
    background: url("../assets/signup.png") no-repeat;
    background-size: cover;
    vertical-align: top;
    color: #fff;
    font-size: 32px;
    font-family: MicrosoftYaHei-Bold;
    cursor: pointer;
  }

  .signup:hover {
    background-image: url("../assets/signup-hover.png");
    text-shadow: 3px 3px 10px;
  }

.personal {
  position: relative;
  display: inline-block;
}
  .personal .lhmj {
    color: #8cc2fa;
    text-decoration: underline;
  }
  .personal a {
    display: inline-block;
    /* width: 100px; */
    color: #fff;
    text-decoration: none;
  }
  .personal a img {
    width:20px;
    vertical-align: middle;
    margin-right: 10px;
    margin-top: -5px;
  }
  .login .guang {
    position: absolute;
    width: 300px;
    right: -100px;
    top: -40px;
    pointer-events: none;
  }
  .guang img {
    width: 100%;
  }
  .loginInfo div{
  font-size: 20px;
}  
.loginInfo img {
  width: 20px;
  vertical-align: middle;
    margin-right: 10px;
    margin-top: -5px;
}


  .fix {
    position: fixed;
    right:0;
    bottom: 0;
  }
  .fix span {
    position: absolute;
    cursor: pointer;
    right:5px;
    top: -5px;
    color: #ddd;
    font-size: 30px;
  }
  .hide {
    display: none;
  }


.prevRanking {
  display: none;
  position: absolute;
  left: 773px;
  width: 150px;
  text-align:center;
  font-size: 22px;
  background: url("../assets/navactive.png") no-repeat;
  /* background-size: cover; */
  color: #fff;
}
.prevRanking div {
  height: 50px;
  line-height: 50px;
  cursor: pointer;
}
.show {
  display: block;
  /* background: red; */
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue